import React from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";

interface CardProps {
  icon: string;
  header: string;
  text: string;
  checked: boolean;
  handleClick?: () => void;
}

const CardContainer = styled.label<{ checked: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.checked ? "#635D98" : "#ccc")};
  border-radius: 8px;
  padding: 20px;
  margin-top: 15px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  background-color: ${(props) => (props.checked ? "#F1F0F6" : "white")};
`;

const IconContainer = styled.div`
  border: 2px solid #e3e1ec;
  border-radius: 50%;
  padding: 10px;
  background-color: #e3e1ec;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

const Text = styled.span`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${colors.DARK_GRAY};
  letter-spacing: 2%;
  padding-top: 4px;
  @media screen and (max-width: 375px) {
    font-family: GT Walsheim Pro;
    font-size: 1px;
    letter-spacing: 0px;
    font-weight: 700;
  }
  @media screen and (max-width: 390px) {
    font-family: GT Walsheim Pro;
    font-size: 11.5px;
    letter-spacing: 0px;
    font-weight: 700;
  }
`;

const HeaderText = styled.span`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  color: ${colors.NAVYBLUE};
  letter-spacing: 0.32px;
`;

const CardTextContainer = styled.span`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  @media screen and (max-width: 375px) {
    padding-left: 10px;
  }
`;

const HeaderTextContainer = styled.span``;

const RadioButton = styled.input.attrs({ type: "radio" })`
  margin-left: auto;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: ${(props) => (props.checked ? "4px" : "16px")};
    height: ${(props) => (props.checked ? "4px" : "16px")};
    border: 2px solid ${(props) => (props.checked ? "#69c914" : "#CFCFCFCF")};
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &::after {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid ${(props) => (props.checked ? "#69c914" : "#0056b3")};
    border-radius: 50%;
    vertical-align: middle;
    position: relative;
    z-index: 0;
    opacity: ${(props) => (props.checked ? "1" : "0")};
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &:checked::before {
    border-color: #69c914;
    background-color: #69c914;
  }
`;

const Card: React.FC<CardProps> = ({
  icon,
  header,
  text,
  checked,
  handleClick,
}) => {
  return (
    <CardContainer checked={checked}>
      <IconContainer>
        <Icon src={icon} alt="icon" />
      </IconContainer>
      <CardTextContainer>
        <HeaderTextContainer>
          <HeaderText>{header}</HeaderText>
        </HeaderTextContainer>
        <Text>{text}</Text>
      </CardTextContainer>
      <RadioButton checked={checked} onClick={handleClick} />
    </CardContainer>
  );
};

export default Card;
